import { useRefinementList } from 'react-instantsearch'

export default function FilterVirtualRefinementList(props) {
  useRefinementList(props)

  return null
}
